import {leftPadWithZeros} from './leftPadWithZeros';

/**
 * Formats a number of seconds into a time text for screen readers.
 * For example, 3745 becomes 1 Hour 2 Minutes 25 Seconds
 *
 * @param totalSeconds the total number of seconds to format to text
 * @returns {string} the formatted time text
 */
export const secondsToText = (totalSeconds: number): string => {
  const isNegative = totalSeconds < 0;

  if (isNegative) {
    // If the time is negative, we make it positive for the calculation below
    // (else we'd get all negative numbers) and reattach the negative sign later.
    totalSeconds = -totalSeconds;
  }

  // Split into separate time parts
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds / 60) - hours * 60;
  const seconds = Math.floor(totalSeconds) % 60;

  const hoursString = hours !== 0 ? `${leftPadWithZeros(hours, 2)} Hours ` : '';
  const minutesString =
    minutes !== 0 ? `${leftPadWithZeros(minutes, 2)} Minutes ` : '';
  const secondsString = `${leftPadWithZeros(seconds, 2)} Seconds`;

  return `${
    isNegative ? '-' : ''
  }${hoursString}${minutesString}${secondsString}`;
};
